import './CardOne.scss';

function CardOne({price, type, img, index}) {
  return (
    <section className="CardOne" key={index}>
      <div className="CardOne_img"></div>
      <div className="CardOne_text">
        <p>{price}</p>
        <p>{type}</p>
      </div>
    </section>
  );
}

export default CardOne;